import { RouteListGetter } from 'App';
import React from 'react';
import { Route } from 'react-router-dom';

const getRuleConfigurationRoutes: RouteListGetter = (lazily, isExperimentEnabled) => {
  if (!isExperimentEnabled('user.isPowerUser')) return <></>;

  const RuleConfigurationPage = lazily('rule-configuration');

  return <Route path="/rule-configuration" element={<RuleConfigurationPage />} />;
};

export default getRuleConfigurationRoutes;
